import {REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS} from "../../../middlewares/api/actions";
import {
    DATAFLOW_PUBLISHING_DATAFLOW_CLONE_SHOW,
    DATAFLOW_PUBLISHING_DATAFLOW_CONTENT_CONSTRAINTS_HIDE,
    DATAFLOW_PUBLISHING_DATAFLOW_CONTENT_CONSTRAINTS_READ,
    DATAFLOW_PUBLISHING_DATAFLOW_DELETE,
    DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_CHANGE,
    DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_HIDE,
    DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_SHOW,
    DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_SUBMIT,
    DATAFLOW_PUBLISHING_DATAFLOW_EDIT,
    DATAFLOW_PUBLISHING_DATAFLOW_EXPORT_SHOW,
    DATAFLOW_PUBLISHING_DETAIL_AGENCIES_READ,
    DATAFLOW_PUBLISHING_DETAIL_ANNOTATIONS_HIDE,
    DATAFLOW_PUBLISHING_DETAIL_ANNOTATIONS_SHOW,
    DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_CHANGE,
    DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_CREATE_SUBMIT,
    DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_READ,
    DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_UPDATE_SUBMIT,
    DATAFLOW_PUBLISHING_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ,
    DATAFLOW_PUBLISHING_DETAIL_DSD_SET,
    DATAFLOW_PUBLISHING_DETAIL_DSD_UNSET,
    DATAFLOW_PUBLISHING_DETAIL_DSDS_HIDE,
    DATAFLOW_PUBLISHING_DETAIL_DSDS_READ,
    DATAFLOW_PUBLISHING_DETAIL_DSDS_SHOW,
    DATAFLOW_PUBLISHING_DETAIL_HIDE,
    DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_HIDE,
    DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_RESET,
    DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_SHOW,
    DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_SUBMIT,
    DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_HIDE,
    DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ,
    DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET,
    DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_SHOW,
    DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_SET,
    DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_UNSET,
    DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_MODAL_CLOSE,
    DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_MODAL_OPEN,
    DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_READ,
    DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_ENDPOINT_PING,
    DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_ENDPOINT_SET,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_PUBLISHING_READ,
    DATAFLOW_PUBLISHING_SELECTED_DATAFLOW_PUBLISHING_DELETE,
    DATAFLOW_PUBLISHING_DETAIL_LINKED_SOURCE_DSD_FOR_LAYOUT_ANNOTATIONS_READ,
    DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_SOURCE_READ,
    DATAFLOW_PUBLISHING_DETAIL_HIERARCHICAL_CODELISTS_READ,
    DATAFLOW_PUBLISHING_DETAIL_ERASE_MAPPING_SET_INFO,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_SHOW,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_FLAG_SET,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_UNSET,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_SET,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_CONTENT_CONSTRAINTS_READ,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_READ,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_HIDE,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_DDB_CONTENT_CONSTRAINT_DELETE,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_IS_ALLOWED_CHANGE,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_TRANSCODING_VERIFY_TIMEPERIOD_FORMAT_CHANGE,
    DATAFLOW_PUBLISHING_LIST_RESET_SUCCESSFUL_FLAG,
    DATAFLOW_PUBLISHING_GET_DATAFLOW_INFO,
    DATAFLOW_PUBLISHING_CLEAR_DATAFLOW_INFO,
    DATAFLOW_PUBLISHING_GET_DATAFLOW_HEADER_INFO,
    DATAFLOW_PUBLISHING_CLEAR_DATAFLOW_HEADER_INFO,
    DATAFLOW_PUBLISHING_WIZARD_HEADER_FORM_CHANGE,
    DATAFLOW_PUBLISHING_WIZARD_HEADER_DELETE,
    DATAFLOW_PUBLISHING_FILTER_CONTENT_COSTRAINTS,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_CHANGE,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHANGE,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHECK,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_SHOW_MODAL_DOWNLOAD_QUERY,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_DSD_READ,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_HIDE,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_PREVIEW_SHOW,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_HIDE,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_SET,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_SHOW,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_UNSET,
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_SHOW,
    DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_COLUMN_VALUES_READ,
    DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ,
    DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_COLUMN_VALUES_RESET,
    DATAFLOW_PUBLISHING_QUERY_TOGGLE_PREVIEW,
    DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE,
    DATAFLOW_PUBLISHING_QUERY_FILTER_MODAL_SUBMIT,
    DATAFLOW_PUBLISHING_QUERY_FILTER_RESET,
    DATAFLOW_PUBLISHING_QUERY_FILTER_RESET_ALL,
    DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CHANGE,
    DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_BLOCK_ADD,
    DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_BLOCK_DELETE,
    DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CONDITION_ADD,
    DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CONDITION_DELETE,
    DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_CHANGE,
    DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE,
} from "./actions";

import {
    CODELIST_ORDER_ANNOTATION_KEY,
    FILTER_MODE_IN,
    getArtefactFromSdmxJsonStructure,
    getArtefactTripletFromUrn,
    getDsdFromSdmxJsonStructure,
    getItemSchemeFromSdmxJsonFactory,
    getSdmxStructuresFromSdmxJson,
    getStringFromArtefactTriplet,
    getUrnFromArtefactTriplet,
    SDMX_JSON_CODELIST_ITEMS_KEY,
    SDMX_JSON_DSD_URN_NAMESPACE
} from "../../../utils/sdmxJson";
import _ from 'lodash';
import {reuseInReducer, reuseReducer} from "../../../utils/reduxReuse";
import dsdDetailModalReducer from "../../../redux-components/redux-dsd-detail-modal/reducer";
import {getCurrentNodeConfig} from "../../../middlewares/current-node-config/middleware";
import contentConstraintDetailModalReducer
    from "../../../redux-components/redux-content-constraint-modal/reducer";
import {
    AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY,
    AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY,
    DATAFLOW_CATALOG_TYPE_ONLY_FILE,
    getCustomAnnotationsFromTabsMap,
    getCustomAnnotationsTabsMap,
    getGenericAnnotations,
    isStrCaseInsensitiveEquals,
} from "../../../utils/annotations";
import {getCurrentUserPermissions} from "../../../middlewares/current-user-permissions/middleware";
import {
    DATAFLOW_TYPE_NORMAL,
    DATAFLOW_TYPE_ONLY_FILE,
    DATAFLOW_TYPE_VIRTUAL
} from "../../../utils/dataflow";
import {prepareDataflows, setLinkedDataflowAnnotationText, setLinkedDataflowAnnotationTitle} from "./utils";
import {
    CONTENT_CONSTRAINT_DETAIL_CREATE_SUBMIT,
    CONTENT_CONSTRAINT_DETAIL_UPDATE_SUBMIT
} from "../../../redux-components/redux-content-constraint-modal/actions";
import {getHeaderContact} from "../../data-manager/dataflow-builder/reducer";
import {QUERY_FORM_FILTER_MODE_PLAIN, QUERY_FORM_FILTER_MODE_TREE} from "../../../components/query-form";
import {
    DOWNLOAD_FORMAT_TYPE_COMPACT,
    DOWNLOAD_FORMAT_TYPE_GENERIC,
    DOWNLOAD_FORMAT_TYPE_CROSSSECTIONAL20,
    DOWNLOAD_FORMAT_TYPE_GENERIC20, DOWNLOAD_FORMAT_TYPE_JSON, DOWNLOAD_FORMAT_TYPE_SDMXCSV,
    DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC
} from "../../../constants/download";
import {getFilterStrFromObj} from "../../../utils/filter";
import {getTreeFilterStrFromObj} from "../../../components/tree-filter/utils";


export const DATAFLOW_PUBLISHING_DSD_DETAIL_PREFIX = "DATAFLOW_PUBLISHING_DSD_DETAIL_PREFIX_";
export const DATAFLOW_PUBLISHING_SELECTED_DSD_DETAIL_PREFIX = "DATAFLOW_PUBLISHING_SELECTED_DSD_DETAIL_PREFIX_";
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO';
export const DATAFLOW_PUBLISHING_CONTENT_CONSTRAINT_PREFIX = 'DATAFLOW_PUBLISHING_CONTENT_CONSTRAINT_PREFIX_';

const DATAFLOW_PUBLISHING_DETAIL_VIRTUAL_DATAFLOW_DSD = {
    id: "VIRTUALDSD",
    agencyID: "MDM",
    version: "1.0"
};

const dataflowsReducer = (
    state = {
        isDetailVisible: false,
        dataflowTriplet: null,
        dataflows: null,
        isDataflowValid: true,
        isAgenciesValid: true,
        isDataflowGeneralTabDirty: false,
        dataflow: null,
        sourceDataflow: null,
        dsdForLayoutAnnotations: null,
        agencies: null,
        allAgencies: null,
        dsds: null,
        isDsdsListVisible: false,
        dsdDetail: null,
        selectedDsdTriplet: null,
        isDsdDetailVisible: false,
        downloadDataflowParams: null,
        downloadDataflowTriplets: null,
        downloadDataflowLang: null,
        cloneDestTriplet: null,
        dataflowAnnotations: null,
        dataflowLayoutAnnotations: null,
        dataflowAnnotationTriplet: null,
        dataflowExportSourceTriplet: null,
        dataflowExportDestination: null,
        dataflowExportReport: null,
        dataflowOwnershipDataflowTripletStr: null,
        dataflowOwnershipOwners: null,
        dataflowOwnershipUsers: null,
        parentsAndChildren: null,
        dataflowCCsDataflowTriplet: null,
        dataflowCCsContentConstraints: null,
        contentConstraintDetail: null,
        isLayoutAnnotationsFormVisible: false,
        dataflowOriginalAnnotations: null,
        itemsPageForLayoutAnnotations: null,
        isLinkedDFEndpointAvailable: null,
        isLinkedDFDataflowsModalOpen: false,
        linkedDFDataflows: null,
        hierarchicalCodelists: null,
        mappingSetIsSuccessCallback: false,
        mappingSetCallbackInfo: null,
        dataflowProductionModalDataflowTriplet: null,
        enabledFetchDataflowProductionModalContentConstraints: null,
        verifyTimePeriodFormat: null,
        dataflowProductionModalContentConstraintIsAllowed: true,
        dataflowProductionModalContentConstraints: null,
        dataflowProductionModalTranscodingMode: DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO,
        successfulAction: false,
        isDataflowProductionModalTranscodingContentConstraintListVisible: null,
        dataflowProductionModalTranscodingContentConstraints: null,
        cubeId: null,
        dataflowInfo: null,
        dataflowHeaderInfo: null,
        readyForFilter: null,
        dlDataflowTriplet: null,
        dlDsdTriplet: null,
        dlDsdDimensions: null,
        showDataflowPreview: false,
        filter: null,
        filterTemp: null,
        treeFilter: {},
        treeFilterTemp: {},
        filterMode: QUERY_FORM_FILTER_MODE_PLAIN,
        filterStr: "",
    },
    action
) => {
    switch (action.type) {
        case DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE: {

            const treeFilterTemp = _.cloneDeep(state.treeFilterTemp);

            treeFilterTemp[action.colName] = {
                mode: action.mode,
                values: treeFilterTemp[action.colName] && treeFilterTemp[action.colName].values
                    ? treeFilterTemp[action.colName].values
                    : []
            };

            const colNames =
                state.dlDsdDimensions.map(({id}) => id);

            const colIndex = colNames.indexOf(action.colName);

            const subsequentColNames = colNames.splice(colIndex + 1);

            // delete filters for subsequent cols
            subsequentColNames.forEach(name => {
                delete treeFilterTemp[name];
            });

            // delete filteredCodelistTree for subsequent cols
            const dlDsdDimensions = [...state.dlDsdDimensions].map(col =>
                    subsequentColNames.includes(col.name)
                        ? ({
                            ...col,
                            filteredCodelistTree: null
                        })
                        : col
                );

            return {
                ...state,
                dlDsdDimensions,
                treeFilterTemp: treeFilterTemp
            };
        }
        case DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_CHANGE:
            return {
                ...state,
                treeFilterTemp: action.treeFilter
            };
        case DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CONDITION_DELETE: {
            const filterTemp = _.cloneDeep(state.filterTemp);
            filterTemp[action.blockIndex].conditions.splice(action.conditionIndex, 1);
            return {
                ...state,
                filterTemp: filterTemp
            };
        }
        case DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CONDITION_ADD: {
            const filterTemp = _.cloneDeep(state.filterTemp);
            const condition = {
                comparisonOperator: null,
                value: null
            };
            if (filterTemp[action.blockIndex].conditions !== null) {
                filterTemp[action.blockIndex].conditions.push(condition);
            } else {
                filterTemp[action.blockIndex].conditions = [condition];
            }
            return {
                ...state,
                filterTemp: filterTemp
            };
        }
        case DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_BLOCK_DELETE: {
            const filterTemp = _.cloneDeep(state.filterTemp);
            filterTemp.splice(action.blockIndex, 1);
            return {
                ...state,
                filterTemp: filterTemp
            };
        }
        case DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_BLOCK_ADD: {
            const block = {
                column: null,
                logicalOperator: 'OR',
                conditions: null
            };
            return {
                ...state,
                filterTemp:
                    state.filterTemp !== null
                        ? (
                            [
                                ...state.filterTemp,
                                block
                            ]
                        )
                        : [block]
            };
        }
        case DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CHANGE: {
            const filterTemp = _.cloneDeep(state.filterTemp);
            if (action.fields.filter.filter(block => block.column !== undefined).length > 0) {
                action.fields.filter = action.fields.filter.map(block => ({
                    ...block,
                    conditions: null
                }));
            }
            return {
                ...state,
                filterTemp: _.merge(filterTemp, action.fields.filter)
            };
        }
        case DATAFLOW_PUBLISHING_QUERY_FILTER_RESET_ALL:
            return {
                ...state,
                filter: [],
                filterTemp: [],
                treeFilter: {},
                treeFilterTemp: {},
                filterStr: "",
            };
        case DATAFLOW_PUBLISHING_QUERY_FILTER_RESET:
            return {
                ...state,
                filterTemp: [],
                treeFilterTemp: {}
            };
        case DATAFLOW_PUBLISHING_QUERY_FILTER_MODAL_SUBMIT:
            return {
                ...state,
                isFilterModalVisible: false,
                filter: state.filterMode === QUERY_FORM_FILTER_MODE_PLAIN ? action.filter : state.filter,
                filterTemp: null,
                treeFilter: state.filterMode === QUERY_FORM_FILTER_MODE_TREE ? action.filter : state.treeFilter,
                treeFilterTemp: {},
                filterStr: action.filterStr,
            };
        case DATAFLOW_PUBLISHING_QUERY_TOGGLE_PREVIEW: {
            return {
                ...state,
                showDataflowPreview: action.showDataflowPreview
            };
        }
        case DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_COLUMN_VALUES_RESET: {
            const dlDsdDimensions =[...state.dlDsdDimensions].map(col =>
                    col.id === action.columnName
                        ? ({
                            ...col,
                            values: null,
                            valuesCount: null
                        })
                        : col
                );

            return {
                ...state,
                dlDsdDimensions
            };
        }
        case DATAFLOW_PUBLISHING_WIZARD_HEADER_FORM_CHANGE: {
            return {
                ...state,
                dataflowHeaderInfo: _.merge(_.cloneDeep(state.dataflowHeaderInfo), action.fields)
            };
        }
        case DATAFLOW_PUBLISHING_CLEAR_DATAFLOW_HEADER_INFO:
            return {...state, dataflowHeaderInfo: null}
        case DATAFLOW_PUBLISHING_CLEAR_DATAFLOW_INFO:
            return {...state, dataflowInfo: null}
        case DATAFLOW_PUBLISHING_LIST_RESET_SUCCESSFUL_FLAG:
            return {
                ...state,
                successfulAction: false
            };
        case DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE: {

            const treeFilterTemp = _.cloneDeep(state.treeFilterTemp);

            treeFilterTemp[action.colName] = {
                mode: treeFilterTemp[action.colName] && treeFilterTemp[action.colName].mode
                    ? treeFilterTemp[action.colName].mode
                    : FILTER_MODE_IN,
                values: action.values
            };

            const colNames =
                _.flatten(Object.keys(state.dlDsdDimensions).map(key => state.dlDsdDimensions[key]))
                    .map(({name}) => name);

            const colIndex = colNames.indexOf(action.colName);

            const subsequentColNames = colNames.splice(colIndex + 1);

            // delete filters for subsequent cols
            subsequentColNames.forEach(name => {
                delete treeFilterTemp[name];
            });

            return {
                ...state,
                dlDsdDimensions: [...state.dlDsdDimensions].map(col => {
                        if (subsequentColNames.includes(col.id)) {
                            return ({
                                ...col,
                                filteredCodelistTree: null
                            });
                        } else {
                            return col;
                        }
                    }),
                treeFilterTemp: treeFilterTemp
            };
        }
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_TRANSCODING_VERIFY_TIMEPERIOD_FORMAT_CHANGE:
            return {
                ...state,
                verifyTimePeriodFormat: action.verifyTimePeriodFormat
            };
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_IS_ALLOWED_CHANGE:
            return {
                ...state,
                dataflowProductionModalContentConstraintIsAllowed: action.isAllowed
            };
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_HIDE:
            return {
                ...state,
                dataflowProductionModalDataflowTriplet: null,
                dataflowProductionModalTranscodingMode: DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO,
                successfulAction: false,
                isDataflowProductionModalTranscodingContentConstraintListVisible: null,
                dataflowProductionModalTranscodingContentConstraints: null,
                dataflowProductionModalContentConstraintIsAllowed: true,
                dataflowProductionModalContentConstraints: null,
                enabledFetchDataflowProductionModalContentConstraints: false,
                cubeId: null,
            };
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_SHOW:
            return {
                ...state,
                dataflowProductionModalDataflowTriplet: action.dataflowTriplet,
                enabledFetchDataflowProductionModalContentConstraints: true,
            };
        case DATAFLOW_PUBLISHING_DETAIL_ERASE_MAPPING_SET_INFO:
            return {
                ...state,
                mappingSetCallbackInfo: null
            }
        case DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_SHOW:
            return {
                ...state,
                isLayoutAnnotationsFormVisible: true
            };
        case DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_HIDE:
            return {
                ...state,
                isLayoutAnnotationsFormVisible: false
            };
        case DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_SUBMIT:
            return {
                ...state,
                isLayoutAnnotationsFormVisible: false,
                dataflow: {
                    ...state.dataflow,
                    annotations: action.annotations
                }
            };
        case DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_RESET:
            return {
                ...state,
                dataflow: {
                    ...state.dataflow,
                    annotations: state.dataflowOriginalAnnotations
                }
            };
        case DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET:
            return {
                ...state,
                itemsPageForLayoutAnnotations: null
            };
        case DATAFLOW_PUBLISHING_DATAFLOW_CONTENT_CONSTRAINTS_HIDE:
            return {
                ...state,
                dataflowCCsDataflowTriplet: null,
                dataflowCCsContentConstraints: null
            };
        case DATAFLOW_PUBLISHING_DATAFLOW_EDIT:
            return {
                ...state,
                isDetailVisible: true,
                mappingSetCallbackInfo: null,
                dataflowTriplet: action.dataflowTriplet,
                isDataflowValid: false,
                isAgenciesValid: false,
                isDataflowGeneralTabDirty: false,
                mappingSetIsSuccessCallback: false
            };
        case DATAFLOW_PUBLISHING_DETAIL_HIDE:
            return {
                ...state,
                isDetailVisible: false,
                mappingSetCallbackInfo: null,
                isLinkedDFDataflowsModalOpen: false,
                dataflowTriplet: null,
                dataflow: null,
                sourceDataflow: null,
                dsdForLayoutAnnotations: null,
                dsds: null,
                isDsdsListVisible: false,
                dsdDetail: null,
                selectedDsdTriplet: null,
                isDsdDetailVisible: false,
                agencies: null,
                allAgencies: null,
                hierarchicalCodelists: null,
                mappingSetIsSuccessCallback: false,
                dlIsDataflowQueryVisible: false,
            };
        case DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_CHANGE: {
            const dataflow = _.cloneDeep(state.dataflow);
            const customizer = (_, src, key) => {
                if (key === "annotations")
                    return src;
                else {
                    return undefined
                }
            };
            const newDataflow = _.mergeWith(dataflow, action.fields, customizer);

            const dataflowTypeIsChanged = newDataflow.dataflowType !== state.dataflow.dataflowType;

            let dsdForLayoutAnnotations = state.dsdForLayoutAnnotations;
            let sourceDataflow = state.sourceDataflow;
            let hasToReadDsdSource = newDataflow.hasToReadDsdSource;

            let newAutoAnnotations = newDataflow.autoAnnotations;
            const currentNodeConfigAnnotations = getCurrentNodeConfig(action).annotations;

            if (dataflowTypeIsChanged) {
                dsdForLayoutAnnotations = null;
                sourceDataflow = null;
                hasToReadDsdSource = newDataflow.dataflowType === DATAFLOW_TYPE_VIRTUAL;

                if (newDataflow.dataflowType === DATAFLOW_TYPE_ONLY_FILE) {
                    // add "dataflow catalog type" annotation
                    const dataflowCatalogTypeAnnotationType = currentNodeConfigAnnotations[AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY].type;
                    newAutoAnnotations = [
                        ...(newAutoAnnotations || []).filter((ann) => ann && !isStrCaseInsensitiveEquals(ann.type, dataflowCatalogTypeAnnotationType)),
                        {
                            type: dataflowCatalogTypeAnnotationType,
                            id: dataflowCatalogTypeAnnotationType,
                            title: DATAFLOW_CATALOG_TYPE_ONLY_FILE
                        }
                    ];
                }
            }

            if (newDataflow.dataflowType === DATAFLOW_TYPE_NORMAL) {
                hasToReadDsdSource = !dsdForLayoutAnnotations;
            }

            if (newDataflow.dataflowType !== DATAFLOW_TYPE_VIRTUAL) {
                // if dataflow type is not "linked (virtual)", remove related annotation
                newAutoAnnotations = (newAutoAnnotations || []).filter((ann) =>
                    (ann && (ann.type || "").toLowerCase() !==
                        (currentNodeConfigAnnotations[AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY].type || "").toLowerCase())
                );
            }

            if (newDataflow.dataflowType !== DATAFLOW_TYPE_ONLY_FILE) {
                // if dataflow type is not "only file", remove related annotation
                newAutoAnnotations = (newAutoAnnotations || []).filter((ann) =>
                    (ann && (ann.type || "").toLowerCase() !==
                        (currentNodeConfigAnnotations[AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY].type || "").toLowerCase())
                );
            }

            // reflect dataflow type in isExternalReference
            newDataflow.isExternalReference = newDataflow.dataflowType === DATAFLOW_TYPE_VIRTUAL;

            const newDataflowIsNotReal = newDataflow.dataflowType === DATAFLOW_TYPE_VIRTUAL || newDataflow.dataflowType === DATAFLOW_TYPE_ONLY_FILE;
            const dataflowIsNotReal = state.dataflow.dataflowType === DATAFLOW_TYPE_VIRTUAL || state.dataflow.dataflowType === DATAFLOW_TYPE_ONLY_FILE;

            return {
                ...state,
                dataflow: {
                    ...newDataflow,
                    isFinal: !state.dataflow.isExternalReference && newDataflow.isExternalReference ? true : newDataflow.isFinal,
                    dsd: newDataflowIsNotReal
                        ? getStringFromArtefactTriplet(DATAFLOW_PUBLISHING_DETAIL_VIRTUAL_DATAFLOW_DSD)
                        : dataflowIsNotReal
                            ? null
                            : state.dataflow.dsd,
                    structure: newDataflowIsNotReal
                        ? getUrnFromArtefactTriplet(DATAFLOW_PUBLISHING_DETAIL_VIRTUAL_DATAFLOW_DSD, SDMX_JSON_DSD_URN_NAMESPACE)
                        : dataflowIsNotReal
                            ? null
                            : state.dataflow.structure,
                    autoAnnotations: newAutoAnnotations,
                    hasToReadDsdSource: hasToReadDsdSource,
                },
                isDataflowGeneralTabDirty: true,
                dataflowOriginalAnnotations: newDataflow.annotations,
                sourceDataflow: sourceDataflow,
                dsdForLayoutAnnotations: dsdForLayoutAnnotations,
            };
        }
        case DATAFLOW_PUBLISHING_DETAIL_DSDS_SHOW:
            return {
                ...state,
                isDsdsListVisible: true
            };
        case DATAFLOW_PUBLISHING_DETAIL_DSDS_HIDE:
            return {
                ...state,
                isDsdsListVisible: false,
                dsds: null
            };
        case DATAFLOW_PUBLISHING_DETAIL_DSD_SET:
            return {
                ...state,
                isDsdsListVisible: false,
                dsds: null,
                dataflow: {
                    ...state.dataflow,
                    dsd: getStringFromArtefactTriplet(action.dsdTriplet),
                    structure: getUrnFromArtefactTriplet(action.dsdTriplet, SDMX_JSON_DSD_URN_NAMESPACE),
                    hasToReadDsdSource: true
                },
                selectedDsdTriplet: action.dsdTriplet,
                dsdDetail: null,
                dsdForLayoutAnnotations: null,
            };
        case DATAFLOW_PUBLISHING_DETAIL_DSD_UNSET:
            return {
                ...state,
                dataflow: {
                    ...state.dataflow,
                    dsd: null,
                    structure: null,
                    hasToReadDsdSource: false
                },
                dsdDetail: null,
                dsdForLayoutAnnotations: null
            };
        case DATAFLOW_PUBLISHING_DETAIL_ANNOTATIONS_SHOW:
            return {
                ...state,
                dataflowAnnotations: action.annotations,
                dataflowAnnotationTriplet: action.triplet
            };
        case DATAFLOW_PUBLISHING_DETAIL_ANNOTATIONS_HIDE:
            return {
                ...state,
                dataflowAnnotations: null,
                dataflowAnnotationTriplet: null
            };
        case DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_SHOW:
            return {
                ...state,
                dataflowLayoutAnnotations: action.annotations,
                dataflowAnnotationTriplet: action.triplet
            };
        case DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_HIDE:
            return {
                ...state,
                dataflowLayoutAnnotations: null,
                dataflowAnnotationTriplet: null
            };
        case DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_SHOW:
            return {
                ...state,
                downloadDataflowTriplets: action.artefactTriplets,
                downloadDataflowLang: action.lang,
                downloadDataflowParams: {
                    format: null,
                    references: false,
                    compression: false,
                    csvSeparator: ";",
                    csvDelimiter: null,
                    csvLanguage: null
                },
            };
        case DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_HIDE:
            return {
                ...state,
                downloadDataflowTriplets: null,
                downloadDataflowLang: null,
                downloadDataflowParams: null
            };
        case DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_CHANGE:
            const downloadDataflowParams = _.cloneDeep(state.downloadDataflowParams);
            return {
                ...state,
                downloadDataflowParams: _.merge(downloadDataflowParams, action.fields)
            };
        case DATAFLOW_PUBLISHING_DATAFLOW_CLONE_SHOW:
            const srcVersionArr = action.srcTriplet.version.split(".");
            const destVersionArr = srcVersionArr.map((num, index) =>
                index === srcVersionArr.length - 1
                    ? Number(num) + 1
                    : num
            );

            return {
                ...state,
                cloneDestTriplet: {
                    ...action.srcTriplet,
                    version: destVersionArr.join(".")
                },
                dataflowTriplet: state.dataflowTriplet ? state.dataflowTriplet : action.srcTriplet,
                isDataflowValid: !!state.dataflow,
                isAgenciesValid: !!state.allAgencies
            };
        case DATAFLOW_PUBLISHING_DATAFLOW_EXPORT_SHOW:
            return {
                ...state,
                dataflowExportSourceTriplet: action.sourceTriplet,
                dataflowExportDestination: {
                    endpoint: null,
                    username: null,
                    password: null,
                    id: action.sourceTriplet.id,
                    agencyID: action.sourceTriplet.agencyID,
                    version: action.sourceTriplet.version
                },
                isAgenciesValid: !!state.allAgencies
            };
        case DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_ENDPOINT_SET: {

            const linkedDataflowNodeAnnotationType =
                (getCurrentNodeConfig(action).annotations[AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY].type || "");
            const autoAnnotations = setLinkedDataflowAnnotationTitle(linkedDataflowNodeAnnotationType, state.dataflow, action.endpointId)

            return {
                ...state,
                dataflow: {
                    ...state.dataflow,
                    autoAnnotations: autoAnnotations,
                    hasToReadDsdSource: false,
                },
                sourceDataflow: null,
                dsdForLayoutAnnotations: null,
            };
        }
        case DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_SET: {
            const id = state.dataflow.id ? state.dataflow.id : action.dataflowTriplet.id;
            const agencyID = state.dataflow.agencyID ? state.dataflow.agencyID : action.dataflowTriplet.agencyID;
            const version = state.dataflow.version ? state.dataflow.version : action.dataflowTriplet.version;

            const linkedDataflowNodeAnnotationType =
                (getCurrentNodeConfig(action).annotations[AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY].type || "");
            const autoAnnotations = setLinkedDataflowAnnotationText(linkedDataflowNodeAnnotationType, state.dataflow, action.dataflowTriplet);

            return {
                ...state,
                dataflow: {
                    ...state.dataflow,
                    id: id,
                    agencyID: agencyID,
                    version: version,
                    autoAnnotations: autoAnnotations,
                    hasToReadDsdSource: true,
                },
                isLinkedDFDataflowsModalOpen: false,
                dsdForLayoutAnnotations: null,
                sourceDataflow: null,
            };
        }
        case DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_UNSET: {
            const linkedDataflowNodeAnnotationType =
                (getCurrentNodeConfig(action).annotations[AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY].type || "");
            const autoAnnotations = setLinkedDataflowAnnotationText(linkedDataflowNodeAnnotationType, state.dataflow, null);

            return {
                ...state,
                dataflow: {
                    ...state.dataflow,
                    autoAnnotations: autoAnnotations,
                    hasToReadDsdSource: false,
                },
                sourceDataflow: null,
                dsdForLayoutAnnotations: null,
            };
        }
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_SHOW_MODAL_DOWNLOAD_QUERY: {
            return {
                ...state,
                dlDataflow: state.dataflow,
                dlCols: state.dlDsdCols,
                dlCheckedCols: state.dlDataflowParams.selCols ? state.dlDataflowParams.selCols : state.dlDsdCols,
                dlIsDataflowQueryVisible: true
            };
        }
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_SHOW:
            return {
                ...state,
                dlDataflowTriplet: action.dataflowTriplet,
                dlDsdTriplet: action.dsdTriplet,
            }
        case DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_MODAL_OPEN:
            return {
                ...state,
                isLinkedDFDataflowsModalOpen: true
            };
        case DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_MODAL_CLOSE:
            return {
                ...state,
                isLinkedDFDataflowsModalOpen: false,
                linkedDFDataflows: null
            };
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHANGE:
            return {
                ...state,
                dlCols: action.cols
            };
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHECK:
            return {
                ...state,
                dlCheckedCols: action.cols
            };
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_CHANGE:
            const dataflowDownloadParams = _.cloneDeep(state.dlDataflowParams);
            return {
                ...state,
                dlDataflowParams: {
                    ..._.merge(dataflowDownloadParams, action.fields),
                    selCols: action.fields.format ? null : state.dlDataflowParams.selCols,
                    filter: action.fields.format ? "" : state.dlDataflowParams.filter
                },
                dlFilter: action.fields.format ? null : state.dlFilter,
                dlRows: action.fields.format ? null : state.dlRows,
                dlCols: action.fields.format ? null : state.dlCols,
                dlCheckedCols: action.fields.format ? null : state.dlCheckedCols,
                filter: action.fields.format ? null : state.filter,
                filterTemp: action.fields.format ? null : state.filterTemp,
                treeFilter: action.fields.format ? {} : state.treeFilter,
                treeFilterTemp: action.fields.format ? {} : state.treeFilterTemp,
                filterMode: (
                    action.fields.format === DOWNLOAD_FORMAT_TYPE_GENERIC ||
                    action.fields.format === DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC ||
                    action.fields.format === DOWNLOAD_FORMAT_TYPE_GENERIC20 ||
                    action.fields.format === DOWNLOAD_FORMAT_TYPE_CROSSSECTIONAL20 ||
                    action.fields.format === DOWNLOAD_FORMAT_TYPE_COMPACT ||
                    action.fields.format === DOWNLOAD_FORMAT_TYPE_SDMXCSV ||
                    action.fields.format === DOWNLOAD_FORMAT_TYPE_JSON
                ) ? QUERY_FORM_FILTER_MODE_TREE : state.filterMode
            };
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_HIDE:
            return {
                ...state,
                dlDataflow: null,
                dlDataflowParams: null,
                dlDsdTriplet: null,
                dlDsdDimensions: null,
                dlDsdCols: null,
                dlDataflowTriplet: null,
                dlIsDataflowQueryVisible: false,
                dlIsPreviewVisible: null,
                cube: null,
                cubeId: null,
                dlFilter: null,
                dlRows: null,
                dlCols: null,
                dlCheckedCols: null,
                filterTemp: null,
                treeFilter: {},
                treeFilterTemp: {},
                filterMode: QUERY_FORM_FILTER_MODE_PLAIN
            };
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_PREVIEW_SHOW:
            return {
                ...state,
                dlIsPreviewVisible: true
            };
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_HIDE:
            return {
                ...state,
                dlIsDataflowQueryVisible: false,
                dlCheckedCols: state.dlDataflowParams.selCols ? state.dlDataflowParams.selCols : null,
                dlFilter: state.dlDataflowParams.filter ? state.dlDataflowParams.filter : null
            };
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_SET:
            return {
                ...state,
                dlIsDataflowQueryVisible: false,
                dlDataflowParams: {
                    ...state.dlDataflowParams,
                    selCols: action.selCols,
                    filter: state.filterMode === QUERY_FORM_FILTER_MODE_PLAIN
                        ? getFilterStrFromObj(
                            action.filter,
                            !!state.dlDsdDimensions
                                ? state.dlDsdDimensions.map(item => ({name: item.id}))
                                : null)
                        : getTreeFilterStrFromObj(
                            action.filter,
                            !!state.dlDsdDimensions && !!state.dlDsdDimensions
                                ? action.selCols
                                : null)
                }
            };
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_SHOW:
            return {
                ...state,
                dlIsDataflowQueryVisible: true
            };
        case DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_UNSET:
            return {
                ...state,
                dlIsDataflowQueryVisible: false,
                dlFilter: null,
                dlRows: null,
                dlCols: null,
                dlCheckedCols: null,
                dlDataflowParams: {
                    ...state.dlDataflowParams,
                    selCols: null,
                    filter: ""
                },
                filter: null,
                filterTemp: null,
                treeFilter: {},
                treeFilterTemp: {},
                filterMode: QUERY_FORM_FILTER_MODE_PLAIN
            };
        case REQUEST_START:
            switch (action.label) {
                case DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_UPDATE_SUBMIT:
                    return {
                        ...state,
                        isDataflowGeneralTabDirty: false,
                        agencies: null,
                        allAgencies: null
                    };
                case DATAFLOW_PUBLISHING_DETAIL_DSDS_READ:
                    return {
                        ...state,
                        dsds: null
                    };
                case DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_ENDPOINT_PING:
                    return {
                        ...state,
                        isLinkedDFEndpointAvailable: false
                    };
                case DATAFLOW_PUBLISHING_DETAIL_HIERARCHICAL_CODELISTS_READ:
                    return {
                        ...state,
                        hierarchicalCodelists: null
                    };
                default:
                    return state;
            }
        case REQUEST_SUCCESS:
            switch (action.label) {
                case DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_COLUMN_VALUES_READ: {
                    const columnValues = [...new Set((action.response.Data || []))];

                    const dlDsdDimensions = [...state.dlDsdDimensions].map(col =>
                            col.id === action.colName
                                ? ({
                                    ...col,
                                    values: columnValues,
                                    valuesCount: action.response.Count
                                })
                                : col
                        );

                    return {
                        ...state,
                        dlDsdDimensions
                    };
                }
                case DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ: {
                    const filteredValues = [...new Set((action.response.Data || []).map(item => item[action.colName]))];

                    const dlDsdDimensions =[...state.dlDsdDimensions].map(col => {
                            if (col.id === action.colName) {
                                const filteredCodelistTree =
                                    filteredValues.map(item => ({"id": item, "name": {"en": item, "it": item}}))
                                return ({
                                    ...col,
                                    filteredCodelistTree,
                                    filteredValues,
                                    filteredCodelistTreeMaxDepth: 1
                                });
                            } else
                                return col;
                        });

                    return {
                        ...state,
                        dlDsdDimensions
                    };
                }
                case DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_DSD_READ:
                    const dsdCols = getDsdFromSdmxJsonStructure(
                        getSdmxStructuresFromSdmxJson(action.response)[0],
                        getCurrentNodeConfig(action).annotations
                    ).dimensions.map(({id}) => id);
                    const dsdInfo = action.response.data.dataStructures[0];
                    const allComponentsObj = dsdInfo.dataStructureComponents;
                    if (!allComponentsObj) return state;
                    const dlDsdDimensions = [...(allComponentsObj.dimensionList && allComponentsObj.dimensionList.dimensions ? allComponentsObj.dimensionList.dimensions : []).map(dim => ({
                        ...dim,
                        icon: 'bar-chart'
                    })), ...(allComponentsObj.dimensionList && allComponentsObj.dimensionList.timeDimensions ? allComponentsObj.dimensionList.timeDimensions : []).map(tDim => ({
                        ...tDim,
                        icon: 'clock-circle'
                    })), ...(allComponentsObj.attributeList && allComponentsObj.attributeList.attributes ? allComponentsObj.attributeList.attributes : []).map(attr => ({
                        ...attr,
                        icon: 'profile',
                        type: "attribute"
                    })), {
                        ...(allComponentsObj.measureList && allComponentsObj.measureList.primaryMeasure ? allComponentsObj.measureList.primaryMeasure : {}),
                        type: "primaryMeasure",
                        icon: 'line-chart'
                    }];
                    return {
                        ...state,
                        dlDsdDimensions,
                        dlDataflowParams: {
                            ...state.dlDataflowParams,
                        },
                        dlDsdCols: dsdCols
                    };
                case DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD: {
                    return {
                        ...state,
                        dlDataflow: null,
                        dlDataflowParams: null,
                        dlDsdTriplet: null,
                        dlDsdDimensions: null,
                        dlDsdCols: null,
                        dlDataflowTriplet: null,
                        dlIsDataflowQueryVisible: false,
                        dlIsPreviewVisible: null,
                        cube: null,
                        cubeId: null,
                        filter: null,
                        treeFilter: null,
                        treeFilterTemp: {},
                        filterMode: QUERY_FORM_FILTER_MODE_PLAIN,
                        dlRows: null,
                        dlCols: null,
                        dlCheckedCols: null
                    };
                }
                case DATAFLOW_PUBLISHING_FILTER_CONTENT_COSTRAINTS: {
                    if (!action.response.Data || !action.response.Data.length) {
                        return ({
                            ...state,
                            itemsPageForLayoutAnnotations: [],
                            readyForFilter: null,
                        });
                    }
                    return ({
                        ...state,
                        readyForFilter: null,
                        itemsPageForLayoutAnnotations: (state.itemsPageForLayoutAnnotations || []).filter(item => action.response.Data.map(item => item[action.colName]).includes(item.id)),
                    });
                }
                case DATAFLOW_PUBLISHING_CLEAR_DATAFLOW_HEADER_INFO:
                    return {...state, dataflowHeaderInfo: null, dataflows: null}
                case DATAFLOW_PUBLISHING_WIZARD_HEADER_DELETE:
                    return {...state, dataflowHeaderInfo: null, dataflows: null}
                case DATAFLOW_PUBLISHING_GET_DATAFLOW_HEADER_INFO:
                    return {
                        ...state, dataflowHeaderInfo: {
                            test: false,
                            name: null,
                            dataSetAgencyId: null,
                            source: null,
                            ...action.response || {},
                            sender:
                                getHeaderContact((action.response && action.response.sender) || null),
                            receiver:
                                getHeaderContact(
                                    (
                                        action.response && action.response.receiver &&
                                        action.response.receiver.length && action.response.receiver[0]
                                    ) || null
                                ),
                            dataflowTriplet: action.dataflowTriplet
                        }
                    }
                case DATAFLOW_PUBLISHING_GET_DATAFLOW_INFO:
                    return {...state, dataflowInfo: {...action.response, dataflowID: action.dataflowTriplet.id}}
                case DATAFLOW_PUBLISHING_CONTENT_CONSTRAINT_PREFIX + CONTENT_CONSTRAINT_DETAIL_CREATE_SUBMIT:
                case DATAFLOW_PUBLISHING_CONTENT_CONSTRAINT_PREFIX + CONTENT_CONSTRAINT_DETAIL_UPDATE_SUBMIT:
                case DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_DDB_CONTENT_CONSTRAINT_DELETE: {
                    return {
                        ...state,
                        dataflowProductionModalContentConstraints: null,
                        enabledFetchDataflowProductionModalContentConstraints: true,
                        successfulAction: true,
                    };
                }
                case DATAFLOW_PUBLISHING_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_READ:
                    return {
                        ...state,
                        dataflowProductionModalTranscodingContentConstraints:
                            (getSdmxStructuresFromSdmxJson(action.response) || [])
                                .map(artefact => getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
                    };
                case DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_CONTENT_CONSTRAINTS_READ: {
                    const annotations = getCurrentNodeConfig(action).annotations;
                    const dataflowCCsContentConstraints = action.response
                        .map(art => getArtefactFromSdmxJsonStructure(art, annotations.annotations))
                        .map(cc => ({
                            ...cc,
                            agencyID: cc.agency
                        }));

                    return {
                        ...state,
                        dataflowProductionModalContentConstraints: dataflowCCsContentConstraints,
                        enabledFetchDataflowProductionModalContentConstraints: false
                    };
                }
                case DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_SET:
                case DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_UNSET:
                case DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_FLAG_SET:
                    return {
                        ...state,
                        successfulAction: true
                    };
                case DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_ENDPOINT_PING:
                    return {
                        ...state,
                        isLinkedDFEndpointAvailable: action.response
                    };
                case DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_READ:
                    return {
                        ...state,
                        linkedDFDataflows:
                            (getSdmxStructuresFromSdmxJson(action.response) || [])
                                .map(artefact => getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
                    };
                case DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ:
                    return {
                        ...state,
                        readyForFilter: action.columnName,
                        itemsPageForLayoutAnnotations: getItemSchemeFromSdmxJsonFactory(
                            SDMX_JSON_CODELIST_ITEMS_KEY,
                            getCurrentNodeConfig(action).annotations,
                            CODELIST_ORDER_ANNOTATION_KEY
                        )(getSdmxStructuresFromSdmxJson(action.response)[0]).codes || []
                    };
                case DATAFLOW_PUBLISHING_LIST_DATAFLOW_PUBLISHING_READ:
                    return {
                        ...state,
                        dataflows: prepareDataflows(action.response, getCurrentNodeConfig(action).annotations),
                    };
                case DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_READ:

                    const userPermissions = getCurrentUserPermissions(action);
                    const customNoneIsAutoAnnotation = userPermissions && userPermissions.rules.includes("CanManageWorkingAnnotation")
                        ? () => false
                        : undefined;

                    const dataflow = getArtefactFromSdmxJsonStructure(getSdmxStructuresFromSdmxJson(action.response)[0], getCurrentNodeConfig(action).annotations, customNoneIsAutoAnnotation);

                    const annotationTabsConfig = getCurrentNodeConfig(action).annotationTabs.tabs;
                    const annotationsConfig = getCurrentNodeConfig(action).annotations;

                    const linkedDataflowAnnotation = annotationsConfig[AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY];
                    const catalogTypeAnnotation = annotationsConfig[AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY];

                    const isExternalReference = !![
                        ...(dataflow.annotations || []),
                        ...(dataflow.autoAnnotations || [])
                    ].find((ann) => ann && isStrCaseInsensitiveEquals(ann.type, linkedDataflowAnnotation.type));
                    const isOnlyFile = !![
                        ...(dataflow.annotations || []),
                        ...(dataflow.autoAnnotations || [])
                    ].find((ann) => ann && isStrCaseInsensitiveEquals(ann.type, catalogTypeAnnotation.type));


                    return {
                        ...state,
                        dataflow: {
                            ...dataflow,
                            isExternalReference,
                            dataflowType:
                                isExternalReference
                                    ? DATAFLOW_TYPE_VIRTUAL
                                    : (
                                        isOnlyFile
                                            ? DATAFLOW_TYPE_ONLY_FILE
                                            : DATAFLOW_TYPE_NORMAL
                                    ),
                            dsd: dataflow.structure ? getStringFromArtefactTriplet(getArtefactTripletFromUrn(dataflow.structure)) : null,
                            hasToReadDsdSource: !isOnlyFile
                        },
                        selectedDsdTriplet: dataflow.structure ? getArtefactTripletFromUrn(dataflow.structure) : null,
                        isDataflowValid: true,
                        dataflowOriginalAnnotations: [
                            ...getGenericAnnotations(dataflow.annotations, annotationTabsConfig, annotationsConfig),
                            ...getCustomAnnotationsFromTabsMap(getCustomAnnotationsTabsMap(dataflow.annotations, annotationTabsConfig)),
                            (dataflow.autoAnnotations || []).find((ann) =>
                                ann && isStrCaseInsensitiveEquals(ann.type, linkedDataflowAnnotation.type)
                            )
                        ],
                        isLinkedDFEndpointAvailable: null,
                        sourceDataflow: null,
                        dsdForLayoutAnnotations: null,
                    };
                case DATAFLOW_PUBLISHING_DETAIL_AGENCIES_READ:
                    return {
                        ...state,
                        agencies: _.pickBy(action.response, (_, agencyID) => !action.allowedAgencies || action.allowedAgencies.includes(agencyID)),
                        allAgencies: action.response,
                        isAgenciesValid: true
                    };
                case DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_CREATE_SUBMIT:
                case DATAFLOW_PUBLISHING_DATAFLOW_DELETE:
                    return {
                        ...state,
                        dataflow: null,
                        dataflows: null,
                        isDetailVisible: false,
                        agencies: null,
                        allAgencies: null,
                        sourceDataflow: null,
                        dsdForLayoutAnnotations: null,
                        mappingSetCallbackInfo: state.dataflow,
                        mappingSetIsSuccessCallback: true,
                    };
                case DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_UPDATE_SUBMIT:
                    return {
                        ...state,
                        dataflow: null,
                        dataflows: null,
                        isDataflowValid: false,
                        isDetailVisible: false,
                        item: null,
                        sourceDataflow: null,
                        dsdForLayoutAnnotations: null,
                        mappingSetCallbackInfo: null,
                        mappingSetIsSuccessCallback: true,
                    };
                case DATAFLOW_PUBLISHING_DETAIL_DSDS_READ:
                    return {
                        ...state,
                        dsds: (getSdmxStructuresFromSdmxJson(action.response) || [])
                            .map(artefact => getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
                    };
                case DATAFLOW_PUBLISHING_SELECTED_DATAFLOW_PUBLISHING_DELETE:
                    return {
                        ...state,
                        dataflow: null,
                        dataflows: null,
                        sourceDataflow: null,
                        dsdForLayoutAnnotations: null,
                        mappingSetIsSuccessCallback: true
                    };
                case DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_SUBMIT:
                    return {
                        ...state,
                        downloadDataflowTriplets: null,
                        downloadDataflowLang: null,
                        downloadDataflowParams: null
                    };
                case DATAFLOW_PUBLISHING_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ:
                case DATAFLOW_PUBLISHING_DETAIL_LINKED_SOURCE_DSD_FOR_LAYOUT_ANNOTATIONS_READ: {
                    const sdmxStructure = getSdmxStructuresFromSdmxJson(action.response);
                    const dsd = (sdmxStructure || []).length > 0
                        ? getDsdFromSdmxJsonStructure(sdmxStructure[0], getCurrentNodeConfig(action).annotations)
                        : null;
                    return {
                        ...state,
                        dataflow: {
                            ...state.dataflow,
                            hasToReadDsdSource: dsd !== null
                        },
                        dsdForLayoutAnnotations: dsd,
                    }
                }
                case DATAFLOW_PUBLISHING_DATAFLOW_CONTENT_CONSTRAINTS_READ:
                    return {
                        ...state,
                        dataflowCCsContentConstraints:
                            action.response
                                .map(art => getArtefactFromSdmxJsonStructure(art, getCurrentNodeConfig(action).annotations))
                                .map(cc => ({
                                    ...cc,
                                    agencyID: cc.agency
                                }))
                    };
                case DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_SOURCE_READ: {
                    const userPermissions = getCurrentUserPermissions(action);
                    const customNoneIsAutoAnnotation = userPermissions && userPermissions.rules.includes("CanManageWorkingAnnotation")
                        ? () => false
                        : undefined;

                    const sourceDataflow = getArtefactFromSdmxJsonStructure(getSdmxStructuresFromSdmxJson(action.response)[0], getCurrentNodeConfig(action).annotations, customNoneIsAutoAnnotation);

                    return {
                        ...state,
                        dataflow: {
                            ...state.dataflow,
                            hasToReadDsdSource: true
                        },
                        sourceDataflow: sourceDataflow,
                        dsdForLayoutAnnotations: null
                    }
                }
                case DATAFLOW_PUBLISHING_DETAIL_HIERARCHICAL_CODELISTS_READ:
                    return {
                        ...state,
                        hierarchicalCodelists: getSdmxStructuresFromSdmxJson(action.response).map(artefact =>
                            getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
                    };
                default:
                    return state;
            }
        case REQUEST_ERROR:
            switch (action.label) {
                case DATAFLOW_PUBLISHING_FILTER_CONTENT_COSTRAINTS: {
                    return ({
                        ...state,
                        readyForFilter: null,
                    });
                }
                case DATAFLOW_PUBLISHING_GET_DATAFLOW_HEADER_INFO:
                    return {...state, dataflowHeaderInfo: null}
                case DATAFLOW_PUBLISHING_GET_DATAFLOW_INFO:
                    return {...state, dataflowInfo: null}
                case DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_READ:
                    return {
                        ...state,
                        isDetailVisible: false,
                        isDataflowValid: true
                    };
                case DATAFLOW_PUBLISHING_SELECTED_DATAFLOW_PUBLISHING_DELETE:
                    return {
                        ...state,
                        dataflows: null,
                        mappingSetIsSuccessCallback: false
                    };
                case DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_SOURCE_READ:
                    return {
                        ...state,
                        dataflow: {
                            ...state.dataflow,
                            hasToReadDsdSource: false
                        },
                        sourceDataflow: null,
                        dsdForLayoutAnnotations: null
                    };
                case DATAFLOW_PUBLISHING_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ:
                case DATAFLOW_PUBLISHING_DETAIL_LINKED_SOURCE_DSD_FOR_LAYOUT_ANNOTATIONS_READ:
                    return {
                        ...state,
                        dataflow: {
                            ...state.dataflow,
                            hasToReadDsdSource: false
                        },
                        dsdForLayoutAnnotations: null,
                        sourceDataflow: null,
                    };
                default:
                    return state;
            }
        default:
            return state;
    }
};

export default reuseInReducer(dataflowsReducer, {
    dsdDetail: reuseReducer(dsdDetailModalReducer, DATAFLOW_PUBLISHING_DSD_DETAIL_PREFIX),
    selectedDsdDetail: reuseReducer(dsdDetailModalReducer, DATAFLOW_PUBLISHING_SELECTED_DSD_DETAIL_PREFIX),
    contentConstraintDetail: reuseReducer(contentConstraintDetailModalReducer, DATAFLOW_PUBLISHING_CONTENT_CONSTRAINT_PREFIX)
});
